/*!
 * ==============================================================
 * This file is generated automatically by the generator.
 * DO NOT UPDATE IT MANUALLY!
 * ==============================================================
 */
export { default as FacebookIcon } from './components/SocialMedia/FacebookIcon';
export { default as GithubIcon } from './components/SocialMedia/GithubIcon';
export { default as LinkedinIcon } from './components/SocialMedia/LinkedinIcon';
export { default as TwitterIcon } from './components/SocialMedia/TwitterIcon';